export const getOtpAlertText = (remainingAttempts: number | null, lockedUntil: number | null): string | null => {
  if (lockedUntil && lockedUntil > Date.now() / 1000) {
    return null;
  }

  if (remainingAttempts === null) return null;

  if (remainingAttempts === 0) {
    return null;
  }

  if (remainingAttempts === 1) {
    return 'Неверный код. Осталась 1 попытка';
  }

  if (remainingAttempts === 2) {
    return 'Неверный код. Осталось 2 попытки';
  }

  if (remainingAttempts <= 4) {
    return 'Проверьте код и попробуйте ещё раз';
  }

  return null;
};
